<template>
  <div class="container setting">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/senior/apply' }">认证申请</el-breadcrumb-item>
        <el-breadcrumb-item>学长详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <!--      <div class="left">
          <div class="status">
            <span class="label">学长状态：</span>
            <el-switch
              v-model="senior.status"
              @change="updateStatus"
            ></el-switch>
          </div>
          <div class="tips">
            <p class="label">
              <i class="el-icon-warning-outline"></i>
              禁用后将不在前端展示
            </p>
          </div>
        </div> -->
        <div class="right">
          <el-button plain
                     @click="handleClose">返回</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main card">
      <h3 class="title">学长详情</h3>
      <div class="baseinfo content">
        <div class="form-header">
          <div class="form-header-inner">基础信息</div>
        </div>
        <el-form ref="userForm"
                 label-width="100px"
                 class="userForm">
          <!--           <el-form-item label="头像：">
            <img class="avatar" :src="senior.avatar" />
          </el-form-item>
          <el-form-item label="昵称：">
            <el-input v-model="senior.nickname" clearable disabled></el-input>
          </el-form-item> -->
          <el-form-item label="昵称：">
            <el-input v-model="senior.nickname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="senior.realname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="性别：">
            <el-select v-model="senior.gender"
                       placeholder="请选择性别">
              <el-option label="学长"
                         :value="1"></el-option>
              <el-option label="学姐"
                         :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="senior.mobile"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="微信号：">
            <el-input v-model="senior.wechat"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="微信名：">
            <el-input v-model="senior.wechat_nickname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="QQ号：">
            <el-input v-model="senior.qq"
                      clearable></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="education content">
        <div class="form-header">
          <div class="form-header-inner">学历信息</div>
        </div>
        <div class="education-wrap">
          <el-form class="form-wrap"
                   label-width="100px">
            <el-form-item label="考研年份：">
              <el-input v-model="senior.recruit_year"
                        clearable
                        maxlength="4"
                        style="width: 100px"></el-input>
            </el-form-item>
            <el-form-item label="录取院校：">
              <el-select v-model="senior.recruit_college_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取专业：">
              <el-select v-model="senior.recruit_major_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取学院：">
              <el-select v-model="senior.recruit_academy_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="academyChange">
                <el-option v-for="(item, index) in academyList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取方向：">
              <el-select v-model="senior.recruit_direction_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="directionChange">
                <el-option v-for="(item, index) in directionList"
                           :key="index"
                           :label="item.direction"
                           :value="item.direction_code">
                  <span>{{ `${item.direction}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试科目：">
              <el-select v-model="senior.test_subject_codes"
                         multiple
                         clearable
                         placeholder="请选择"
                         style="width: 600px"
                         @change="handleSubject">
                <el-option v-for="(item, index) in subjectsList"
                           :key="index"
                           :label="item.subject_name"
                           :value="item.subject_code">
                  <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-for="(item,index) in scoreList"
                          :key="index"
                          :label="item.subjectName+'：'">
              <el-input v-model="item.score"
                        style="width: 130px"> <template slot="append">分</template></el-input>
            </el-form-item>

            <el-form-item label="初试总分：">
              <el-input v-model="senior.initial_test_score"
                        clearable
                        maxlength="4"
                        style="width: 130px"><template slot="append">分</template></el-input>
            </el-form-item>
            <!-- <el-form-item label="科目分数：">
              <el-input v-model="senior.test_subject_scores"
                        clearable
                        style="width: 200px"></el-input>
            </el-form-item> -->
            <el-form-item label="录取类型：">
              <!--  <span>{{ renderRecruitType(senior.recruit_type) }}</span> -->
              <el-select v-model="senior.recruit_type"
                         placeholder="请选择录取类型">
                <el-option label="第一志愿上岸"
                           :value="1"></el-option>
                <el-option label="调剂上岸"
                           :value="2"></el-option>
                <el-option label="推免"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取证明：">
              <el-image style="width: 120px; height: 120px"
                        :src="senior.recruit_certify_img"
                        :preview-src-list="[senior.recruit_certify_img]">
              </el-image>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="education content">
        <div class="form-header">
          <div class="form-header-inner">服务信息</div>
        </div>
        <div class="education-wrap">

          <el-form class="form-wrap"
                   label-width="100px">
            <el-form-item label="荣誉标签：">
              <el-tag v-if="honor.length >0"
                      v-for="(item,index) in honor"
                      :key="index"
                      style="marginRight:10px"> {{item}}</el-tag>
            </el-form-item>
            <el-form-item label="其他荣誉标签：">
              <el-input v-model="otherHonor"></el-input>
            </el-form-item>
            <el-form-item label="服务提供：">
              <p v-for="(item, $i) in senior.provide_services
                  ? senior.provide_services.split(',')
                  : []"
                 :key="$i">
                {{ renderProvideService(item) }}
              </p>
            </el-form-item>
            <el-form-item label="优势描述：">
              <!-- <span>{{ senior.additional || "-" }}</span> -->
              <el-input type="textarea"
                        clearable
                        v-model="senior.additional"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="footer"
           v-if="senior.status == 0">
        <el-button type="primary"
                   @click="handleApprove">通过</el-button>
        <el-button type="danger"
                   @click="handleReject">驳回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 之前是学长详情，现在是学长申请详情
/* import { seniorOne, seniorUpdateStatus, seniorUpdate } from "@/api/senior"; */
import {
  seniorApplyOne,
  editSeniorApply,
  seniorApplyApprove,
  seniorApplyReject,
} from '@/api/senior'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'

export default {
  components: {},
  data() {
    return {
      senior: {},
      majorList: [],
      subjectsList: [],
      academyList: [],
      directionList: [],
      collegeCode: '',
      majorCode: '',
      scoreList: [],
      honor: [],
      otherHonor: '',
    }
  },
  created() {
    this.fetchSeniorInfo()
    this.$store.dispatch('getAllColleges')
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    // 学长基本信息
    fetchSeniorInfo() {
      seniorApplyOne({ id: this.$route.params.seniorId }).then((res) => {
        if (res) {
          res.status = res.status == 1 ? true : false
          this.senior = res
          this.senior.test_subject_codes =
            this.senior.test_subject_codes.split(',')
          this.getAcademy(this.senior.recruit_college_code)
          this.getMajor(
            this.senior.recruit_college_code,
            this.senior.recruit_academy_code
          )
          this.getSubjectsByMajorCode(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
          this.majorDirect(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
          this.honor = []
          let otherHonor = []
          if (this.senior.honor_tags != '') {
            this.honor = this.senior.honor_tags.split(',').filter((v) => {
              return !v.includes('#')
            })
            otherHonor = this.senior.honor_tags.split(',').filter((v) => {
              return v.includes('#')
            })
            this.otherHonor = otherHonor.toString()
          }
          this.scoreList = []
          this.senior.test_subject_names.split(',').map((item, index) => {
            this.senior.test_subject_scores.split(',').map((v, id) => {
              if (index == id) {
                this.scoreList.push({
                  subjectName: item,
                  score: v,
                })
              }
            })
          })
          this.scoreList.map((items, k) => {
            this.senior.test_subject_codes.map((p, i) => {
              if (k == i) {
                items.code = ''
                items.code = p
              }
            })
          })
          console.log('this.scoreList', this.scoreList)
        }
      })
    },
    handleSubject(e) {
      console.log('this.scoreList', this.scoreList)
      console.log('e', e)
      let scorep = []
      this.scoreList.map((item) => {
        e.map((v) => {
          if (item.code == v) {
            scorep.push({
              subjectName: item.subjectName,
              score: item.score,
              code: v,
            })
          }
        })
      })
      this.scoreList = scorep
      console.log('444', this.scoreList)

      // console.log('this.code', this.senior.test_subject_codes)
    },
    // 返回
    handleClose() {
      this.$router.go(-1)
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    renderProvideService(type) {
      /*    const services = {
           1: "资料：专业课资料/复习书记/笔记等",
           2: "解答：专业课复习相关问题",
           3: "录课：专业课知识点梳理及精讲",
           4: "辅导：参与研发专业课辅导教案并授课",
           5: "其他：考研其他资询辅导服务",
         }; */
      const services = {
        1: '资料-整理备考资料',
        2: '经验-分享上岸经验',
        3: '小讲-录制语音课程',
        4: '辅导-辅导1v1学员',
        5: '研讯-汇总专业数据',
      }
      return services[type] || ''
    },
    renderRecruitType(type) {
      const recruitTypes = {
        1: '第一志愿上岸',
        2: '调剂上岸',
        3: '推免',
      }
      return recruitTypes[type] || ''
    },
    renderGender(type) {
      const genders = {
        1: '学长',
        2: '学姐',
      }
      return genders[type] || ''
    },
    directionChange(e) {
      this.senior.recruit_direction_name = this.directionList.find((item) => {
        return item.direction_code === e //筛选出匹配数据
      }).direction
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      console.log('拿到学院code', e)
      this.collegeCode = e
      this.senior.recruit_major_code = ''
      this.senior.recruit_major_name = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_direction_code = ''
      this.senior.recruit_direction_name = ''
      this.senior.recruit_college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.$nextTick(() => {
        this.getMajor(e)
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    academyChange(e) {
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_name = this.academyList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
        console.log('this.academyList学院名称', this.academyList)
      })
    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
        console.log('this.majorList专业名称', this.majorList)
      })
    },
    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
          console.log(this.directionList, 'this.directionList')
        }
      })
    },
    // 录取专业选择后还要搜索相对应的专业名称
    majorChange(e) {
      this.majorCode = e
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.recruit_major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name

      this.collegeCode &&
        this.majorCode &&
        this.majorDirect(this.collegeCode, this.majorCode)

      this.$nextTick(() => {
        this.getSubjectsByMajorCode(this.senior.recruit_college_code, e)
      })
      this.$nextTick(() => {
        this.getAcademy(this.senior.recruit_college_code, e)
      })
    },
    getSubjectsByMajorCode(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    formateSenior() {
      let arr = []
      this.senior.test_subject_codes.forEach((item) => {
        arr.push(
          this.subjectsList.find((v) => {
            return v.subject_code === item //筛选出匹配数据
          }).subject_name
        )
      })
      this.senior.test_subject_codes = this.senior.test_subject_codes.join(',')
      this.senior.test_subject_names = arr.join(',')
    },
    handleSubmit() {
      this.formateSenior()
      let query = {
        ...this.senior,
      }
      editSeniorApply(query)
        .then((res) => {
          this.$message.success(`学长学姐状态更新成功`)
          // 刷新数据
          this.fetchSeniorInfo()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    handleApprove() {
      // 二次确认
      this.$confirm('确定审核通过吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          seniorApplyApprove({ senior_apply_id: this.senior.id }).then(
            (res) => {
              this.$message.success('申请已通过')
              this.$emit('submit')
              this.fetchSeniorInfo()
              this.$router.go(-1)
            }
          )
        })
        .catch(() => {})
    },
    handleReject() {
      // 二次确认
      this.$confirm('确定要驳回申请吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          seniorApplyReject({ senior_apply_id: this.senior.id }).then((res) => {
            this.$message.success('申请已驳回')
            this.$emit('submit')
            this.fetchSeniorInfo()
            this.$router.go(-1)
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
.setting {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
    .tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }

    .content {
      // display: flex;
      margin-top: 20px;
    }
  }
  .baseinfo {
    .avatar {
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
    .userForm {
      width: 700px;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
  }
  .education {
    .education-wrap {
      display: flex;
    }
    .form-wrap {
      flex: 1;
    }
  }
  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
